import type { ValueOf } from './ValueOf';

export const ApprovalOperation = {
  REQUEST: 'REQUEST',
  APPROVE: 'APPROVE',
  CANCEL: 'CANCEL',
  /**
   * @deprecated use CANCEL instead
   */
  RECALL: 'RECALL',
  REJECT: 'REJECT',
  REQUEST_CHANGES: 'REQUEST_CHANGES',
} as const;

export type ApprovalOperation = ValueOf<typeof ApprovalOperation>;
